import { api } from '../consumerApiSlice';
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        postConsumerV2AuthValidate: build.mutation({
            query: (queryArg) => ({
                url: `/consumer/v2/auth/validate`,
                method: 'POST',
                body: queryArg.postConsumerV2AuthValidate,
            }),
        }),
        postConsumerV2ReceiptsReceiptUuidIdentityVerification: build.mutation({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}/identity_verification`,
                method: 'POST',
            }),
        }),
        postConsumerV2ReceiptsReceiptUuidIdentityVerificationComplete: build.mutation({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}/identity_verification/complete`,
                method: 'POST',
                body: queryArg.postConsumerV2ReceiptsReceiptUuidIdentityVerificationComplete,
            }),
        }),
        patchConsumerV2ReceiptsReceiptUuidSign: build.mutation({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}/sign`,
                method: 'PATCH',
                body: queryArg.patchConsumerV2ReceiptsReceiptUuidSign,
            }),
        }),
        getConsumerV2ReceiptsReceiptUuid: build.query({
            query: (queryArg) => ({
                url: `/consumer/v2/receipts/${queryArg.receiptUuid}`,
            }),
        }),
        getConsumerV2TreatmentEstimatesToken: build.query({
            query: (queryArg) => ({
                url: `/consumer/v2/treatment_estimates/${queryArg.token}`,
            }),
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as consumerApplicationsApi };
export const { usePostConsumerV2AuthValidateMutation, usePostConsumerV2ReceiptsReceiptUuidIdentityVerificationMutation, usePostConsumerV2ReceiptsReceiptUuidIdentityVerificationCompleteMutation, usePatchConsumerV2ReceiptsReceiptUuidSignMutation, useGetConsumerV2ReceiptsReceiptUuidQuery, useLazyGetConsumerV2ReceiptsReceiptUuidQuery, useGetConsumerV2TreatmentEstimatesTokenQuery, useLazyGetConsumerV2TreatmentEstimatesTokenQuery, } = injectedRtkApi;
